import { useState } from "react";
import Hero from "./Hero";
import Container from "./ui/Container";
import SectionHeader from "./ui/SectionHeader";
import contactImg from "../assets/Contact.jpg";
import toast, { Toaster } from "react-hot-toast";
import emailjs from "emailjs-com";

export default function Contact() {
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        message: "",
    });

    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();

        emailjs
            .send(
                "service_kjmnrqe",
                "template_idixueh",
                formData,
                "A1gOssbqaHNuOkhYJ"
            )
            .then(() => {
                toast.success("Thank you! Our team will reach out to you shortly.");
                setFormData({ name: "", email: "", message: "" });
            })
            .catch((err) => {
                console.error("Email send error:", err);
                toast.error("Something went wrong. Please try again later.");
            });
    };

    return (
        <>
            <Hero />
            <Toaster position="top-right" reverseOrder={false} />
            <section className="py-16">
                <Container>
                    <div className="grid md:grid-cols-2 gap-12 items-center">
                        {/* Left: Form */}
                        <div>
                            <SectionHeader
                                title="Contact Us"
                                subtitle="We're here to assist you with any queries. Fill out the form and our team will reach out to provide support."
                            />
                            <form className="max-w-xl space-y-4" onSubmit={handleSubmit}>
                                <input
                                    type="text"
                                    name="name"
                                    value={formData.name}
                                    onChange={handleChange}
                                    placeholder="Name"
                                    className="w-full border rounded px-4 py-2"
                                    required
                                />
                                <input
                                    type="email"
                                    name="email"
                                    value={formData.email}
                                    onChange={handleChange}
                                    placeholder="Email"
                                    className="w-full border rounded px-4 py-2"
                                    required
                                />
                                <textarea
                                    name="message"
                                    value={formData.message}
                                    onChange={handleChange}
                                    placeholder="Your Query"
                                    className="w-full border rounded px-4 py-2 h-28"
                                    required
                                />
                                <button
                                    type="submit"
                                    className="w-full bg-blue-600 text-white py-3 rounded-lg hover:bg-blue-700 transition-colors"
                                >
                                    Send Message
                                </button>
                            </form>
                        </div>

                        {/* Right: Image */}
                        <div className="flex justify-center">
                            <img
                                src={contactImg}
                                alt="Contact Illustration"
                                className="rounded-lg shadow-lg object-cover w-full max-w-md"
                            />
                        </div>
                    </div>
                </Container>
            </section>
        </>
    );
}
